// Renders an admin-editable copy string that may contain lightweight inline markup
// (<strong>, <em>, <a href>, <br>) so links and bold survive being moved into the editable
// content model. Content is authored only by the Super Admin (trusted), so raw HTML is
// acceptable here — the same trust model as the rest of the admin surface.
export default function RichText({ html, as: Tag = 'p', className }) {
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: html || '' }} />;
}
